export const initialLayout = {
  lg: [
    { w: 1, h: 1, x: 0, y: 0, i: "kpi1", moved: false, static: true },
    { w: 1, h: 1, x: 1, y: 0, i: "kpi2", moved: false, static: true },
    { w: 1, h: 1, x: 2, y: 0, i: "kpi3", moved: false, static: true },
    { w: 1, h: 1, x: 3, y: 0, i: "kpi4", moved: false, static: true },
  ],
  md: [
    { w: 1, h: 1, x: 0, y: 0, i: "kpi1", moved: false, static: true },
    { w: 1, h: 1, x: 1, y: 0, i: "kpi2", moved: false, static: true },
    { w: 1, h: 1, x: 2, y: 0, i: "kpi3", moved: false, static: true },
    { w: 1, h: 1, x: 3, y: 0, i: "kpi4", moved: false, static: true },
  ],
  sm: [
    { w: 1, h: 1, x: 0, y: 0, i: "kpi1", moved: false, static: true },
    { w: 1, h: 1, x: 1, y: 0, i: "kpi2", moved: false, static: true },
    { w: 1, h: 1, x: 2, y: 0, i: "kpi3", moved: false, static: true },
    { w: 1, h: 1, x: 3, y: 0, i: "kpi4", moved: false, static: true },
  ],
  xs: [
    { w: 1, h: 1, x: 0, y: 0, i: "kpi1", moved: false, static: true },
    { w: 1, h: 1, x: 1, y: 0, i: "kpi2", moved: false, static: true },
    { w: 1, h: 1, x: 2, y: 0, i: "kpi3", moved: false, static: true },
    { w: 1, h: 1, x: 3, y: 0, i: "kpi4", moved: false, static: true },
  ],
  xxs: [
    { w: 1, h: 1, x: 0, y: 0, i: "kpi1", moved: false, static: true },
    { w: 1, h: 1, x: 1, y: 0, i: "kpi2", moved: false, static: true },
    { w: 1, h: 1, x: 2, y: 0, i: "kpi3", moved: false, static: true },
    { w: 1, h: 1, x: 3, y: 0, i: "kpi4", moved: false, static: true },
  ],
};
